// extracted by mini-css-extract-plugin
export default {"CategoryRadioItemGroup":"NewPrice_CategoryRadioItemGroup__T5eKB","DefinitionSection":"NewPrice_DefinitionSection__IUvL0","PriceSection":"NewPrice_PriceSection__szmKF"};